import React from "react";
import MainContainer from "../MainContainer";
import Footer from "../Footer";

export default function Merch() {
	return (
		<>
			<MainContainer
				title="no merch at this time"
				src="/images/100x.jpg"
				className="main-primary-background-image"
			/>
			<Footer />
		</>
	);
}
